import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// store
import { Subject, Subscription } from 'rxjs';
// services
import { ErrorHandler } from '../../shared/services/error-handler.service';
import { SharedService } from '../../shared/services/shared-service.service';
// models
import { TimeslotRequest } from '../models/timeslot-request.interface';
import { TimeslotResponse } from '../models/timeslot-response.interface';
// globals
import { API_PATH, SUBSCRIPTION_KEY, TIMESLOTS } from '../../shared/globals';
import { BookingService } from './booking.service';

@Injectable({
  providedIn: 'root',
})
export class TimeslotService {
  private _getTimeslotesSubscription: Subscription;
  public timeslotSubject$: Subject<any> = new Subject();

  constructor(
    private _http: HttpClient,
    private _bookingService: BookingService,
    private _errorService: ErrorHandler,
    private _sharedService : SharedService
  ) {}

  getTimeslots(request: TimeslotRequest) {
    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    this._bookingService.updateD2dstate();

    request.slotNumber = this._sharedService.getCurrentSlotNumber()

    let headers = new HttpHeaders();
    headers=headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    if (this._getTimeslotesSubscription) { this._getTimeslotesSubscription.unsubscribe(); }
    this._getTimeslotesSubscription = this._http
      .post(API_PATH + TIMESLOTS, request, {headers:headers})
      .subscribe((ts: any) => {
        let reverseTimeSlot = ts;
        for (let i = 0; i < reverseTimeSlot.timeSlotDates?.length; i++) {
          reverseTimeSlot.timeSlotDates[i].timeslotGroups.reverse();
        }
        const timeslots: TimeslotResponse = reverseTimeSlot;
        this.timeslotSubject$.next(timeslots);
      },
      err => { this._errorService.handleError(err); });
  }
}


